<!--
 * @Description: 我的订单
 * @Date: 2020年11月13日11:19:23
-->
<template>
  <div style="background:#fff">
    <div>
      <table-render
        height="52vh"
        ref="tableRender"
        v-if="rowKey && config"
        :rowKey="rowKey"
        :config="config"
        :propData="{ query: { ...routeQuery } }"
        :beforeSelectAll="beforeSelectAll"
        @handBeforeSearch="handBeforeSearch"
        @handleSearch="handleSearch"
        @select="
          (selection, row, $event) => handelSelect(selection, row, $event)
        "
        @select-all="(selection, row, $event) => handelSelectAll(selection)"
        @changeActive="clearTableSelection"
        @changeChildActive="clearTableSelection"
        @respondFinished="respondFinished"
        @tabChange="tabChange"
        @hook:mounted="onTableMounted"
      >
        <!-- 批量操作 start-->
        <template slot="batchAction" v-if="unpayActivation && isMaster">
          <p style="width: 100%;margin-bottom: 5px; color: red;">
            温馨提示：只能选择一种项目参与人类型支付！
          </p>
          <div class="batch-actions__info" :key="tableTabIndex">
            <!-- <span class="batch-actions__btn" @click="selectAllByRowKey">
              全选
            </span> -->
            <span class="batch-actions__btn" @click="clearTableSelection">
              清空
            </span>
            <i
              class="el-icon-shopping-cart-2 batch-actions__info__icon"
              style="font-size: 20px; margin: 0 8px;cursor:pointer"
            ></i>
            <span class="batch-actions__count">
              已选订单数：
              <span class="batch-actions__info__mark">{{ dataCount }}</span>
              本次需打款总金额：
              <span class="batch-actions__info__mark">
                {{ sumAmount | moneyFixed }}
              </span>
            </span>
          </div>
          <div
            class="batch-actions__info"
            style="background-color:#f0f9eb;margin-left:10px;"
            v-if="sumServiceAmount"
          >
            <span class="batch-actions__count">
              含待支付平台服务费：
              <span class="batch-actions__info__mark" style="color:#67c23a">
                {{ sumServiceAmount | moneyFixed }}
              </span>
              <el-popover
                placement="top-start"
                trigger="hover"
                width="500"
                @after-leave="resetServicePricePopover"
                v-if="needTotalArray.length"
              >
                <el-table height="300" :data="needTotalArrayGetter">
                  <el-table-column
                    property="orderNo"
                    label="订单编号"
                  ></el-table-column>
                  <el-table-column
                    property="projectName"
                    label="项目名称"
                  ></el-table-column>
                  <el-table-column
                    property="createDate"
                    label="提交日期"
                  ></el-table-column>
                  <el-table-column label="金额">
                    <template slot-scope="scope">
                      <p>
                        {{ scope.row.platformServicesPrice | moneyFixed }}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page.sync="needTotalArrayIndex"
                  :page-size="needTotalArrayPageSize"
                  layout="total, prev, pager, next"
                  :total="needTotalArray.length"
                ></el-pagination>
                <i slot="reference" class="el-icon-warning-outline"></i>
              </el-popover>
            </span>
          </div>
          <div
            class="batch-actions__info"
            style="background-color:#f0f9eb;margin-left:10px;"
            v-if="sumBusServiceAmount"
          >
            <span class="batch-actions__count">
              含待支付商务服务费：
              <span class="batch-actions__info__mark" style="color:#67c23a">
                {{ sumBusServiceAmount | moneyFixed }}
              </span>
              <el-popover
                placement="top-start"
                trigger="hover"
                width="500"
                @after-leave="resetServicePricePopover"
                v-if="needTotalArray.length"
              >
                <el-table height="300" :data="busNeedTotalArrayGetter">
                  <el-table-column
                    property="orderNo"
                    label="订单编号"
                  ></el-table-column>
                  <el-table-column
                    property="projectName"
                    label="项目名称"
                  ></el-table-column>
                  <el-table-column
                    property="createDate"
                    label="提交日期"
                  ></el-table-column>
                  <el-table-column label="金额">
                    <template slot-scope="scope">
                      <p>
                        {{ scope.row.platformServicesPrice | moneyFixed }}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  @current-change="busHandleCurrentChange"
                  :current-page.sync="busNeedTotalArrayIndex"
                  :page-size="busNeedTotalArrayPageSize"
                  layout="total, prev, pager, next"
                  :total="busNeedTotalArray.length"
                ></el-pagination>
                <i slot="reference" class="el-icon-warning-outline"></i>
              </el-popover>
            </span>
          </div>
          <!-- 无权限 -->
          <el-button
            v-if="hasPayRule"
            v-show="isMaster"
            style="margin-left:10px"
            :loading="btnLoading.value"
            class="btn"
            type="primary"
            @click="toPayOrder"
            size="mini"
          >
            前往支付
          </el-button>
        </template>
        <template slot="batchAction" v-if="paidActivation && isMaster">
          <div
            class="batch-actions__info"
            style="min-width:100px"
            :key="tableTabIndex"
          >
            <span class="batch-actions__btn" @click="selectAllByRowKey">
              全选
            </span>
            <span class="batch-actions__btn" @click="clearTableSelection">
              清空
            </span>
          </div>
        </template>
        <!-- 批量操作 ended-->
      </table-render>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { main } from './config';
import { mapGetters } from 'vuex';
import {
  csoCustomerOrder,
  isOverrunQuota,
  listNoPayOrderAllV2,
  totalNoPayCsoCustomOrder,
  checkOrderPay,
  checkPayBank
} from '@/api/ajax.js';
import { getLastMonthAndDay } from '@/components/tableRender/util';
import { moneyFixed } from '@/tools/money.js';
import { deepClone } from '@/tools';
import {
  formatOrdersFieldByType,
  isRevokePeople,
  proxyData,
  selection2StringForCsoCustomOrderIds,
  useQuotaDialog,
  imitateAjax
} from '@/page/settlementCenter/utils';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import { Notification } from 'element-ui';
import { createMsgbox } from '../utils/create-msgbox';

const rowKey = 'idPriceType';

export default {
  provide() {
    return {
      _parent: this // 把当前实例传递给后续弹层使用
    };
  },
  name: 'OrderMgmt',
  data() {
    return {
      config: null,
      backupSelectionLength: 0, // 已选数据len，判断操作后是勾选还是取消勾选，用于当前全选
      tableResp: null,
      tableTabIndex: 0,
      sumAmount: 0,
      sumBusServiceAmount: 0,
      sumServiceAmount: 0,
      dataCount: 0,
      needTotalArray: [], //待支付平台服务费列表
      busNeedTotalArray: [], //待支付商务服务费列表
      btnLoading: {},
      needPayServicesPrice: null,
      needTotalArrayIndex: 1,
      needTotalArrayPageSize: 3,
      busNeedTotalArrayIndex: 1,
      busNeedTotalArrayPageSize: 3,
      payTypeTabActive: '0', // 切换与created中初始化菜单会重置该值
      elTableRef: null, // tableRender中table元素
      tableRenderRef: null, // 当前tableRender元素
      routeQuery: this.$route.query // 跳转进入使用携带参数为默认值，切换订单类型，项目/批次也会携带。切换线上线下则清空query。
    };
  },
  methods: {
    /**
     * @description: 重置页码，防止清空后再选没有数据
     */
    resetServicePricePopover() {
      this.needTotalArrayIndex = 1;
      this.busNeedTotalArrayIndex = 1;
    },

    tabChange(index) {
      this.tableTabIndex = index;
      this.clearTableSelection();
    },
    /**
     * @description: 筛选出是否有其他银行选项或其他付款方式
     * @param {Array} selection 已选的数据集合
     * @param {Array|Object} selected 当前选中的数据或集合
     * @return {Boolean} true 有其他银行或其他付款方式
     */
    hasDifferentBank(selection = [], selected = []) {
      // 筛选出集合中所有的银行字段，对象属性有一个以上则表示有其他银行
      const _selected = Array.isArray(selected) ? selected : [selected];

      const getDifferenceValues = key => {
        return [...selection, ..._selected].reduce((pre, cur) => {
          const currentValue = cur[key];
          if (currentValue) {
            pre[currentValue] = 1;
          }
          return pre;
        }, {});
      };
      // 不同支付通道
      const differenceBankType = getDifferenceValues(PAY_BANK_TYPE_KEY);
      // 不同支付方式
      const differencePayType = getDifferenceValues(PAY_TYPE_KEY);

      if (Object.keys(differenceBankType).length > 1) {
        this.$message({
          type: 'error',
          message: '不同支付通道的订单不可一起支付'
        });
        return true;
      }
      if (Object.keys(differencePayType).length > 1) {
        this.$message({
          type: 'error',
          message: '不同服务商付款方式的订单不可一起支付'
        });
        return true;
      }
      return false;
    },
    handBeforeSearch(row, searchItem) {
      if (row.costType == 1 && row.payPassagewayCode && this.paidActivation) {
        this.tableRenderRef.$refs['search'].moreBtnArr[0].disabled = false;
        if (
          searchItem[4].id == 'wanchengshijian' &&
          searchItem[5].val == 1 &&
          !searchItem[4].val
        ) {
          this.$set(searchItem[4], 'val', getLastMonthAndDay());
        }
      } else {
        this.tableRenderRef.$refs['search'].moreBtnArr[0].disabled = true;
      }
    },
    handleSearch(query) {
      if (this.paidActivation) {
        this.tableRenderRef.$refs['search'].moreBtnArr[0].disabled = !(
          +query.costType === 1 && query.payPassagewayCode
        );
        this.clearTableSelection();
      } else {
        this.tableRenderRef.$refs['search'].moreBtnArr[0].disabled = false;
      }
    },
    handleCurrentChange(value) {
      this.needTotalArrayIndex = value;
    },
    busHandleCurrentChange(value) {
      this.busNeedTotalArrayIndex = value;
    },
    /**
     * @description: 本页全选前
     * @return {boolean} false，全选后续流程不执行
     */
    beforeSelectAll() {
      // 只有待支付使用是否可全选
      if (!this.unpayActivation) return true;
      const {
        userEnterpriseType,
        payPassagewayCode,
        payType
      } = this.tableRenderRef.searchQuery;
      // 全部勾选必须选择【项目参与人类型】
      if (!userEnterpriseType || !payPassagewayCode || !payType) {
        this.$message({
          type: 'error',
          message: '请选择【项目参与人类型】、【支付通道】、【服务商付款方式】'
        });
        return;
      }
      return true;
    },
    /**
     * @description: 本页全选
     * @param {array<object>} selection 已选项
     */
    async handelSelectAll(selection) {
      if (this.unpayActivation && this.hasDifferentBank(selection)) {
        // 存在不同项目费用则取消勾选
        this.elTableRef.store.states.selection = this.elTableRef.store.states.selection.filter(
          item => {
            return selection[0][PAY_BANK_TYPE_KEY] !== item[PAY_BANK_TYPE_KEY];
          }
        );
        return;
      }
      if (this.unpayActivation && selection.length) {
        await checkPayBank({
          ...formatOrdersFieldByType(selection)
        });
      }
      const deletedNeedPayIds = []; // 需手动清除不可勾选的服务费集合
      // selection中所有的项目服务费，如果两个项目同一个服务费，则添加两次，防止同一服务费出现跨页项目费清空
      const selectionNeedPayServicesPriceListForIds = selection.reduce(
        (pre, cur) => {
          if (cur.needPayServicesPriceList) {
            cur.needPayServicesPriceList.forEach(k => {
              pre.push(k[rowKey]);
            });
          }
          return pre;
        },
        []
      );
      // 遍历当前视图数据
      this.elTableRef.tableData.map(item => {
        /*
            修改服务费的disabled状态，并判断关联服务费是否仅存在当前页数据中，如果存在其他页面关联则不会删除
            selectable为2证明是已关联服务费
          */
        if (
          item.selectable === 2 &&
          !selectionNeedPayServicesPriceListForIds.includes(item[rowKey])
        ) {
          deletedNeedPayIds.push(item[rowKey]);
          item.selectable = 1;
        }
      });
      /*
          如果已选数小于备份数，则说明是取消勾选操作，需要手动清除disabled状态的选中数据（select-all只会勾选/清除可点击状态的数据）
          取消操作不会再执行后续逻辑
        */
      if (selection.length < this.backupSelectionLength) {
        // this.elTableRef.store.states.selection 为直接修改源数据，ref.selection没有setter
        this.elTableRef.store.states.selection = this.elTableRef.store.states.selection.filter(
          item => {
            return !deletedNeedPayIds.includes(item[rowKey]);
          }
        );
        return;
      }
      // 勾选逻辑
      const csoCustomOrderIds = selection2StringForCsoCustomOrderIds(selection);
      // 存在项目类型
      if (this.unpayActivation && csoCustomOrderIds) {
        const _this = this;
        let needPayFlag = false;
        let needPayServicesPriceList = [];
        try {
          // 判断项目费用是否同一交易结构
          const checkRes = await checkOrderPay({
            customOrderIds: csoCustomOrderIds
          });
          if (
            createMsgbox(_this, checkRes, ({ orderNos, batchOrderNos }) => {
              _this.elTableRef.store.states.selection = _this.elTableRef.store.states.selection.filter(
                item => {
                  // 按项目展示
                  if (+_this.tableRenderRef.searchQuery.tag === 2) {
                    return !orderNos.includes(item.orderNo);
                  } else {
                    // 按批次展示
                    return !batchOrderNos
                      .split(',')
                      .some(val => item.batchOrderNo.includes(val));
                  }
                }
              );
            })
          ) {
            return;
          }

          // 获取需支付服务费信息
          const query = formatOrdersFieldByType(this.elTableSelection);
          const {
            pdata: servicesData
          } = await csoCustomerOrder.needPayServicesPriceInfo({
            ...query
          });
          // 项目中是否有对应服务费
          if (servicesData.totalPrice > 0) {
            needPayFlag = true;
            needPayServicesPriceList = servicesData.needPayServicesPriceList;
          }
          // 有服务费
          if (needPayFlag) {
            this.$xrkDialog({
              title: '提示',
              showConfirm: false,
              showCancel: false,
              showClose: false,
              'before-close': () => {
                // 存在不同项目费用则取消勾选
                _this.$nextTick(() => {
                  _this.elTableRef.store.states.selection = _this.elTableRef.store.states.selection.filter(
                    item => {
                      return item.priceType !== 1;
                    }
                  );
                  _this.elTableRef.toggleRowSelection(
                    _this.elTableRef.store.states.selection,
                    false
                  );
                });
                _this.$xrkDialog.remove();
              },
              $slots: {
                default: this.$createElement(
                  require('./child/toPayFee').default,
                  {
                    props: {
                      needPayServicesPriceList
                    },
                    on: {
                      confirm(data) {
                        // 服务费
                        let formatData = data.map(item => {
                          return {
                            ...item,
                            [rowKey]: item[rowKey],
                            id: item.id
                          };
                        });
                        // 遍历视图数据并把服务费设置disabled
                        _this.elTableRef.tableData.map(item => {
                          if (data.some(k => k[rowKey] === item[rowKey])) {
                            item.selectable = 2;
                          }
                        });
                        // 同步到selection
                        _this.tableRenderRef.selectAllByRowKey({
                          superKeys: formatData,
                          useSeachInit: false
                        });
                        _this.$xrkDialog.remove();
                      },
                      cancel(data) {
                        // 服务费
                        let formatData = data.map(item => {
                          return {
                            [rowKey]: item[rowKey]
                          };
                        });
                        // 取消操作需要同步修改selection，select-all没有异步处理。
                        _this.$nextTick(() => {
                          _this.elTableRef.store.states.selection = _this.elTableRef.store.states.selection.filter(
                            item => {
                              return !(
                                item.priceType === 1 ||
                                formatData.some(k => k[rowKey] === item[rowKey])
                              );
                            }
                          );
                          // _this.getSelectionOrders();
                        });
                        _this.elTableRef.clearSelection();
                      }
                    }
                  }
                )
              }
            });
          } else {
            // 无服务费直接赋值
            this.elTableRef.selection = selection;
          }
        } catch (e) {
          // 存在不同项目费用则取消勾选
          _this.elTableRef.store.states.selection = _this.elTableRef.store.states.selection.filter(
            item => {
              return item.priceType !== 1;
            }
          );
        }
      }
      this.backupSelectionLength = this.elTableRef.selection.length;
    },
    getNeedPayServicesPriceInfo(csoCustomOrderIds) {
      return csoCustomerOrder.needPayServicesPriceInfo({ csoCustomOrderIds });
    },
    /**
     * @desc 全选，
     * @param scope {Object:{tableRef,tableResp}}
     */
    async selectAllByRowKey() {
      // 待支付勾选
      if (this.unpayActivation) {
        // 全选后先同步列表数据与搜索参数
        this.tableRenderRef.$refs.search.sure();
        const {
          userEnterpriseType,
          payPassagewayCode
        } = this.tableRenderRef.searchQuery;

        // 全部勾选必须选择【项目参与人类型】
        if (!userEnterpriseType || !payPassagewayCode) {
          this.$message({
            type: 'error',
            message: '请选择【项目参与人类型】及【支付通道】'
          });
          return;
        }
        try {
          const { pdata } = await listNoPayOrderAllV2(
            this.tableRenderRef.searchQuery
          );
          const customOrderIds = selection2StringForCsoCustomOrderIds(pdata);
          // 无选择数据
          if (!customOrderIds) {
            this.$message({
              type: 'error',
              message: '无可勾选项目费用数据'
            });
            return;
          }
          // 服务费置为2，不可选
          pdata.forEach(item => {
            item.priceType === 2 && (item.selectable = 2);
          });
          this.elTableRef.tableData.map(item => {
            item.selectable = item.priceType === 2 ? 2 : 1;
          });
          // 合并已选择与将要勾选的数据
          const mergeSelection = [...pdata];
          this.elTableSelection.forEach(item => {
            if (!customOrderIds.includes(item.idPriceType)) {
              mergeSelection.push(item);
            }
          });
          // 判断项目费用是否同一交易结构
          checkOrderPay({
            customOrderIds: selection2StringForCsoCustomOrderIds(
              mergeSelection
            ),
            userEnterpriseType
          })
            .then(checkRes => {
              const _this = this;
              if (
                createMsgbox(_this, checkRes, ({ orderNos, batchOrderNos }) => {
                  _this.elTableRef.store.states.selection = _this.elTableRef.store.states.selection.filter(
                    item => {
                      // 按项目展示
                      if (+_this.tableRenderRef.searchQuery.tag === 2) {
                        return !orderNos.includes(item.orderNo);
                      } else {
                        // 按批次展示
                        return !batchOrderNos
                          .split(',')
                          .some(val => item.batchOrderNo.includes(val));
                      }
                    }
                  );
                })
              ) {
                return;
              }

              this.tableRenderRef.selectAllByRowKey({
                superKeys: pdata,
                useSeachInit: true
              });
              this.backupSelectionLength = pdata.length;
            })
            .catch(() => {
              this.tableRenderRef.selectAllByRowKey({
                superKeys: pdata,
                useSeachInit: true
              });
              this.backupSelectionLength = pdata.length;
              // 拦截则取消勾选项目费用和当页全选 handelSelectAll 逻辑保持一致
              this.elTableRef.store.states.selection = this.elTableRef.store.states.selection.filter(
                item => {
                  return item.priceType !== 1;
                }
              );
            });
        } catch (e) {
          console.error('selectAllByRowKey error: ', e);
        }
      } else {
        // 已支付批量下载勾选
        const { pdata } = await csoCustomerOrder.payOrderMinInfo({
          ...this.tableRenderRef.searchQuery
        });
        this.tableRenderRef.selectAllByRowKey({
          superKeys: pdata,
          useSeachInit: false
        });
      }
    },
    clearTableSelection() {
      this.dataCount = 0;
      this.sumAmount = 0;
      this.sumServiceAmount = 0;
      this.sumBusServiceAmount = 0;
      this.needTotalArray = [];
      this.busNeedTotalArray = [];
      this.backupSelectionLength = 0;
      this.tableRenderRef.clearTableSelection();
      this.elTableRef.tableData.map(item => {
        item.selectable = 1;
      });
    },
    /*
      获取当前勾选项的总金额与数量
    */
    async getSelectionOrders() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const query = formatOrdersFieldByType(this.elTableSelection);
      const userEnterpriseType = this.tableRenderRef.searchQuery
        .userEnterpriseType;
      const { pdata: totalData } = await totalNoPayCsoCustomOrder({
        ...query,
        userEnterpriseType
      });
      Object.assign(this.$data, totalData);
      if (query.csoOrderServicesIds || query.csoBusServicesIds) {
        const {
          pdata: ServicesData
        } = await csoCustomerOrder.tipsPayServicesPriceInfo({
          ...query
        });
        this.needTotalArray = ServicesData.csoOrderServicesList;
        this.busNeedTotalArray = ServicesData.csoBusServicesList;
      }
      if (!this.elTableSelection.length) {
        this.sumAmount = 0;
        this.dataCount = 0;
        this.sumBusServiceAmount = 0;
        this.sumServiceAmount = 0;
      }
      loading.close();
    },
    /**
     * @description: 单个勾选，只有待支付有该流程
     * @param {array} selection 勾选数据
     * @param {object} row 当前操作数据
     */
    async handelSelect(selection = [], row) {
      if (!this.unpayActivation) return;
      if (this.hasDifferentBank(selection, row)) {
        this.elTableRef.selection.pop();
        return;
      }
      const _this = this;
      // 判断row勾选状态，true已勾选 false取消勾选
      const isSelected = selection.some(item => {
        return item[rowKey] === row[rowKey];
      });
      const { needPayServicesPriceList = [] } = row;
      // 项目费用
      if (row.priceType === 1) {
        // 取消勾选，判断是否有需要修改服务费disabled
        if (!isSelected && needPayServicesPriceList.length) {
          // selection中所有的项目服务费，如果两个项目同一个服务费，则添加两次，防止同一服务费出现跨页项目费清空
          const selectionNeedPayServicesPriceListForIds = selection.reduce(
            (pre, cur) => {
              if (cur.needPayServicesPriceList) {
                cur.needPayServicesPriceList.forEach(k => {
                  pre.push(k[rowKey]);
                });
              }
              return pre;
            },
            []
          );
          // 当前row中的服务费
          const rowNeedPayServicesPriceListForIds = needPayServicesPriceList.map(
            item => item[rowKey]
          );
          this.elTableRef.tableData.forEach(item => {
            // 只对当前项目订单的服务费进行处理，并且selection中没有其他项目费关联该服务费
            if (
              rowNeedPayServicesPriceListForIds.includes(item.idPriceType) &&
              !selectionNeedPayServicesPriceListForIds.includes(
                item.idPriceType
              )
            ) {
              item.selectable = 1;
            }
          });
          return;
        }
      }
      // 勾选
      if (selection.some(k => k.id === row.id) && isSelected) {
        try {
          // 项目费用
          if (row.priceType === 1) {
            // 判断项目费用是否同一交易结构
            const checkRes = await checkOrderPay({
              customOrderIds: selection2StringForCsoCustomOrderIds(selection)
            });

            if (
              createMsgbox(_this, checkRes, () => {
                _this.elTableRef.selection.pop();
              })
            ) {
              return;
            }
          }

          // 有服务费
          if (needPayServicesPriceList.length) {
            this.$xrkDialog({
              title: '提示',
              showConfirm: false,
              showCancel: false,
              'before-close': () => {
                _this.$xrkDialog.remove();
                _this.elTableRef.selection.pop();
              },
              $slots: {
                default: this.$createElement(
                  require('./child/toPayFee').default,
                  {
                    props: {
                      needPayServicesPriceList
                    },
                    on: {
                      confirm(data) {
                        _this.elTableRef.tableData.map(item => {
                          if (data.some(k => k[rowKey] === item[rowKey])) {
                            item.selectable = 2;
                          }
                        });
                        _this.tableRenderRef.selectAllByRowKey({
                          superKeys: data,
                          useSeachInit: false
                        });
                        _this.$xrkDialog.remove();
                      },
                      cancel() {
                        _this.elTableRef.selection.pop();
                      }
                    }
                  }
                )
              }
            });
          }
        } catch (e) {
          _this.elTableRef.selection.pop();
        }
      }
    },
    async toPayOrder() {
      this.btnLoading = proxyData({
        value: false
      });
      if (this.elTableSelection.length) {
        //校验委托代开(线上)订单关联人员是否签署合同
        const query = formatOrdersFieldByType(this.elTableSelection);
        const {
          pdata: { status, cacheKey, msg }
        } = await csoCustomerOrder.checkOrderSign({ ...query });
        if (+status === 1) {
          this.$alert(
            `<p>项目执行人：<span style="color:red;">${msg}</span>有合同未签署完成，请通知相关人员签署合同后再进行支付！</p>`,
            '提示',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '导出未签合同人员名单'
            }
          ).then(() => {
            this.$downloadFile(
              `${csoCustomerOrder.exportOrderNoSignPeople}?cacheKey=${cacheKey}`,
              true
            );
          });
          return;
        }
        // 只有组合订单执行
        if (this.elTableSelection.some(k => k.priceType === 1)) {
          this.btnLoading.value = true;
          let csoCustomOrderIds = selection2StringForCsoCustomOrderIds(
            this.elTableSelection
          );
          try {
            // 是否限额
            await isRevokePeople(
              this.elTableSelection.filter(item => item.priceType === 1)
            );
            // 是否退出
            await isOverrunQuota(
              {
                csoCustomOrderIds
              },
              { noNotification: true }
            ).catch(err => {
              setTimeout(() => {
                Notification({
                  title: '失败',
                  message: err.message || err.returnMsg || '服务器异常',
                  type: 'error'
                });
              }, 0);
              throw err;
            });
            this.btnLoading.value = false;
          } catch ({ data, message, returnMsg, code }) {
            this.btnLoading.value = false;
            // 交易结构冲突
            if (+code === -2) {
              useQuotaDialog.call(
                this,
                {},
                imitateAjax(data),
                require('@/page/settlementCenter/components/orderTips/conflict')
                  .default
              );
            }
            if (+code === -1) {
              useQuotaDialog.call(this, {}, imitateAjax(data));
            }
            return;
          }
        }
        this.$xrkDialog({
          title: '前往支付',
          showConfirm: false,
          showCancel: false,
          $slots: {
            default: this.$createElement(
              require('./child/toPayOrder').default,
              {
                props: {
                  preSelection: this.elTableSelection,
                  userEnterpriseType: this.tableRenderRef.searchQuery
                    .userEnterpriseType
                }
              }
            )
          }
        });
        return false;
      }
      this.$message({
        type: 'error',
        message: '请选择订单'
      });
    },
    /* 分页后当前列表callback，selection中有数据才会执行：
       如果项目费用存在对应的服务费用,则服务费用设置为disabled。
    */
    async respondFinished() {
      if (this.elTableSelection.length === 0) {
        return;
      }
      // Selection中priceType不存在为1的
      if (!this.elTableSelection.some(item => item.priceType === 1)) {
        return;
      }
      // 获取已勾选的项目费用对应的服务费数据。
      let csoCustomOrderIds = selection2StringForCsoCustomOrderIds(
        this.elTableSelection
      );
      if (csoCustomOrderIds && this.unpayActivation) {
        let { pdata } = await csoCustomerOrder.needPayServicesPriceInfo({
          csoCustomOrderIds
        });
        let needPayIds = []; // 必须支付集合
        pdata.needPayServicesPriceList.forEach(params => {
          needPayIds.push(params[rowKey]);
        });
        // 必须支付数据，勾选状态设为disabled
        this.elTableRef.tableData.forEach(item => {
          if (needPayIds.includes(item[rowKey])) {
            this.$set(item, 'selectable', 2);
          }
        });
      }
    },
    async initTable() {
      this.config = null; // 重新渲染tableRender
      const dMain = deepClone(main);
      // 无权限，失效订单
      if (!this.hasPayRule) {
        dMain[2].childMenu.forEach(menu => {
          menu.moreBtnArr = [];
          menu.fields.forEach((field, fieldIndex) => {
            if (field.label === '操作') {
              menu.fields.splice(fieldIndex, 1);
            }
          });
        });
      }
      // 子账号没有待支付勾选功能
      if (!this.isMaster) {
        dMain[0].childMenu.forEach(menu => {
          menu['fields'][0]['visible'] = false;
        });
      }
      /*
        使用el-table中的selection引用
        调用el-table中clearSelection时有问题，该方法是直接selection = []改变了引用，所以在select事件中还需要在指向下引用
      */
      // this.selection = this.elTableRef.selection;
      this.config = dMain;
    },
    onTableMounted() {
      // 防止出现tableRender内组件未加载完毕
      setTimeout(() => {
        this.tableRenderRef = this.$refs.tableRender;
        this.elTableRef = this.tableRenderRef.$refs.table;
        this.backupSelectionLength = this.elTableRef.selection.length;
        this.elTableRef.store.states.rowKey = this.rowKey;
      });
    }
  },
  components: { tableRender },
  computed: {
    ...mapGetters(['isMaster', 'hasPayRule']),
    // 本次打款总金额
    totalOrderPrice() {
      return moneyFixed(
        this.elTableSelection.reduce((pre, cur) => {
          return pre + cur.orderPrice;
        }, 0)
      );
    },
    // 当前table渲染的config
    currentTableConfig() {
      return this.config ? this.config[this.tableTabIndex] : {};
    },
    rowKey() {
      if (!this.currentTableConfig.name) return '';
      // 已支付订单使用downLoadSign，其他使用idPriceType
      if (this.paidActivation) return 'downLoadSign';
      return 'idPriceType';
    },
    needTotalArrayGetter() {
      return this.needTotalArray.slice(
        (this.needTotalArrayIndex - 1) * this.needTotalArrayPageSize,
        this.needTotalArrayIndex * this.needTotalArrayPageSize
      );
    },
    busNeedTotalArrayGetter() {
      return this.busNeedTotalArray.slice(
        (this.busNeedTotalArrayIndex - 1) * this.busNeedTotalArrayPageSize,
        this.busNeedTotalArrayIndex * this.busNeedTotalArrayPageSize
      );
    },
    elTableSelection() {
      if (this.elTableRef) {
        return this.elTableRef.selection;
      } else {
        return [];
      }
    },
    unpayActivation() {
      return this.currentTableConfig.name === '待支付订单';
    },
    paidActivation() {
      return this.currentTableConfig.name === '已支付订单';
    }
  },
  watch: {
    elTableSelection: {
      deep: true,
      handler(v) {
        if (this.unpayActivation) {
          this.getSelectionOrders();
          // 之前的payType Tab切换方式没了所以在此处切换payType供前往支付后的弹层使用
          this.$store.commit(
            'orderMgmt/SET_PAYTYPE',
            v.length ? v[0].payType : ''
          );
        }
        this.backupSelectionLength = v.length;
      }
    }
  },
  async created() {
    // 初始重置payType为0，防止aside切换后tab保持为之前选项
    this.$store.commit('orderMgmt/SET_PAYTYPE', '');
    this.initTable();
  }
};
</script>
<style>
.checkMessage {
  width: 650px !important;
}
</style>
